import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8741ccc0&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BreadcrumbItem: require('/app/components/breadcrumb/BreadcrumbItem.vue').default,Breadcrumb: require('/app/components/breadcrumb/Breadcrumb.vue').default,ListHeaderTitle: require('/app/components/list/ListHeaderTitle.vue').default,Heading: require('/app/components/heading/Heading.vue').default,Pagination: require('/app/components/pagination/Pagination.vue').default,ListSerial: require('/app/components/list/ListSerial.vue').default})
